import ColorButtonGroup from '@components/v2/ui/ColorButton/ColorButtonGroup';
import { ColorButtonItem } from '@components/v2/ui/ColorButton/colorButton.types';
import { Box } from '@mui/material';
import { MouseEvent } from 'react';
import { ProductCardV2TestIds } from '../../../../../utils/testIds/ProductCardV2.testIds';
import Typography from '../../../../v2/ui/Typography/Typography';
import { ProductCardV2ColorsProps } from './productCardV2Colors.types';
import useProductCardV2Colors from './useProductCardV2Colors';

const ProductCardV2Colors = ({
  allColors,
  selectedColor,
  tabIndex = 0,
  onColorClick,
}: ProductCardV2ColorsProps) => {
  const { containerRef, visible, overflow } = useProductCardV2Colors({ allColors, selectedColor });

  const items: ColorButtonItem[] = visible.map((color) => ({
    id: color.productColorId,
    label: color.name,
    hexcode: color.hexcode,
    imageUrl: color.isImage || !color.hexcode ? color.imageUrl : undefined,
    testId: `${ProductCardV2TestIds.COLOR_DOT_PREFIX}${color.productColorId}`,
  }));

  const selectedItemId = visible.find((color) => color.id === selectedColor?.id)?.productColorId;

  const handleSelect = (productColorId: string, event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onColorClick(productColorId);
  };

  return (
    <Box ref={containerRef} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <ColorButtonGroup
        items={items}
        selectedId={selectedItemId}
        tabIndex={tabIndex}
        onSelect={handleSelect}
      />

      {overflow > 0 && (
        <Typography variant="micro2" color="textSecondary">
          +{overflow}
        </Typography>
      )}
    </Box>
  );
};

export default ProductCardV2Colors;
